import { Button } from "@mui/material";
import SvgIcon from "@mui/material/SvgIcon";
import i18n from "../i18n";
import styles from "./back-button.module.css";
import CaretLeft from "../images/portal/caret-left.svg?react";

type BackButtonProps = {
	onBack: () => void;
	ariaLabel?: string;
};

export default function BackButton({ onBack, ariaLabel }: BackButtonProps) {
	return (
		<Button
			variant="text"
			className={styles.button}
			onClick={onBack}
			startIcon={
				<SvgIcon>
					<CaretLeft />
				</SvgIcon>
			}
			aria-label={ariaLabel}
			disableFocusRipple
		>
			{i18n.t("portal.components.backButtonTSX.back")}
		</Button>
	);
}
